/** Enlace del botón DONÁ en el header (UTM header escuelas). */
export const DONATION_HEADER_URL =
  "https://app.greenpeace.org.ar/coupon/regular/forms/registration?app=escuelasm&utm_source=web&utm_medium=hub&utm_content=28000-headerescuelas&utm_term=todos&utm_campaign=GreenpeaceEnLasEscuelas";

/** Enlace del botón Doná ahora en la sección de donación de la home. */
export const DONATION_SECTION_URL =
  "https://app.greenpeace.org.ar/coupon/regular/forms/registration?app=escuelasm&utm_source=web&utm_medium=hub&utm_content=28000-bannerhomeescuelas&utm_term=todos&utm_campaign=GreenpeaceEnLasEscuelas";
